<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { authMethods } from "@/state/helpers";
import { format } from 'date-fns';
import { getFirebaseBackend } from '@/helpers/firebase/authUtils';
import collect from 'collect.js';
import { mapState } from 'vuex';
import Swal from 'sweetalert2';

/**
 * Cards component
 */
export default {
  page: {
    title: "Tempahan",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      is_tempahah: true,
      is_user_admin: false,
      hariIni: new Date(),
      tempah: null,
      hariIniStr: format(new Date(),'yyyy-MM-dd'),
      title: "Senarai Tempahan",
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Senarai",
          active: true
        }
      ]
    };
  },
  watch: {
    hariIniStr:function(val1) {
      this.senaraiTempahan(val1.replace(/-/g,'/'))
    }
  },
  methods: {
    luluskanPermohonan(id) {
      getFirebaseBackend().lulusMohon(id).then(() => {
        Swal.fire("Kemaskini berjaya!");
        this.senaraiTempahan(this.hariIniStr.replace(/-/g,'/'))
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Kemaskini tidak berjaya!",
          footer: error
        });
      });
    },
    tidakLuluskanPermohonan(id) {
      getFirebaseBackend().tidakLulusMohon(id).then(() => {
        Swal.fire("Kemaskini berjaya!");
        this.senaraiTempahan(this.hariIniStr.replace(/-/g,'/'))
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Kemaskini tidak berjaya!",
          footer: error
        });
      });
    },
    ...authMethods,
    senaraiTempahan(xtarikh) {
      getFirebaseBackend().getTempahan(xtarikh).then((response) => {
        this.is_tempahah = true
        const allDoc = []
        response.forEach((doc) => {
              // doc.data() is never undefined for query doc snapshots
              const doc_data = doc.data()
              allDoc.push(doc_data)
          })
          if (allDoc.length > 0) {
            this.is_tempahah = false
          }
          return allDoc
      }).then((dt) => {
        this.tempah =  collect(dt).groupBy('pkg').map(item => item.chunk(3)).all()
        console.log('this.tempah',this.tempah)
        // v-for="(chuck_inti,chuck_inti_i) in collect(p).chuck(3).all()" v-bind:key="chuck_inti_i
        // console.log("List => haha,",collect(this.tempah).groupBy('pkg').all())
      })
    }
  },
  computed: {
    ...mapState({
      currentUser: 'auth'
    })
  },
  mounted() {
    console.log("user:",this.$store.state.auth.currentUser)
    console.log("is user admin:",this.$store.state.auth.is_user_admin)
    this.is_user_admin = this.$store.state.auth.is_user_admin;
    this.senaraiTempahan(this.hariIniStr.replace(/-/g,'/'))
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col">
        <div class="card">
          <!-- border border-3 border-success -->
          <div class="card-body">
            <div class="row">
              <div class="col">
                <form class="form-horizontal" role="form">
                  <b-form-group
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="Tarikh"
                    label-for="date"
                  >
                    <b-form-input id="date" class="col-12 col-lg-3" v-model="hariIniStr" type="date"></b-form-input>
                  </b-form-group>
                </form>
                <!-- <span class="d-none d-xl-inline-block ml-1">{{ $t('navbar.dropdown.kevin.text')}}</span> -->
              </div>
            </div>
            <div class="row p-1 bg-primary w-100"></div>
            <div class="row p-1 w-100"></div>
            <div class="row py-1" v-if="is_tempahah">
              <b-alert show variant="danger">Tiada tempahan pada tarikh ini</b-alert>
            </div>
            <div class="row py-1">
              <div class="col-12 col-md-4" v-for="(p,nm,id) in tempah" v-bind:key="id">
                <!-- <div class="col-12"></div> -->
                <b-badge variant="primary" class="font-size-16">{{ nm }}</b-badge>
                <div class="row py-2" v-for="(chuck_inti,chuck_inti_i) in p" v-bind:key="chuck_inti_i">
                  <div class="col-12 col-md-12" v-for="(inti,inti_i) in chuck_inti" v-bind:key="inti_i">
                    <div class="col">
                      <!-- Simple card -->
                      <b-card :img-src='inti.url' img-alt="Card image" img-top>
                        <b-card-title>
                          <h4 class="card-title">{{ inti.bilik }}</h4>
                          <small><strong>{{ inti.tajuk }}</strong></small>
                        </b-card-title>
                        <b-card-text>
                          <div class="row">
                            <div class="col-1"><i class="ri-contacts-line font-size-15 d-xl-inline-block"></i></div>
                            <div class="col "><strong><small>{{ inti.fullname }}</small></strong>, <code class="highlighter-rouge">{{ inti.sekolah_ppd }}, </code><em style="color: #cec104;">{{ inti.sektor }}</em></div>
                          </div>
                          <div class="row">
                            <div class="col-1"><i class="ri-group-line font-size-15 d-xl-inline-block"></i></div>
                            <div class="col "><code class="highlighter-rouge">{{ inti.bil_peserta }}</code> <small>peserta</small></div>
                          </div>
                          <div class="row" v-for="(slot) in inti.slot" v-bind:key="slot">
                            <div class="col-1"><i class="ri-time-line font-size-15 d-xl-inline-block"></i></div>
                            <div class="col "><small>{{ slot }}</small></div>
                          </div>
                          <div class="row p-1 w-100" v-if="'peralatan' in inti"></div>
                          <div class="row" v-for="(alat,alat_key,alat_i) in inti.peralatan" v-bind:key="alat_i">
                            <div class="col" v-if="alat>0"><small>{{ alat_key }}</small> <code class="highlighter-rouge">{{ alat }}</code></div>
                          </div>
                          <div class="row">
                            <div class="col-1"><i class="ri-question-line font-size-15 d-xl-inline-block"></i></div>
                            <div class="col "><code class="highlighter-rouge">{{ inti.status_permohonan }}</code></div>
                          </div>
                          <div class="row" v-if="currentUser.currentUser.email == inti.pemohon || currentUser.is_user_admin">
                            <div class="" v-for="(alat,alat_key,alat_i) in inti.files" v-bind:key="alat_i">
                              <a class="ri-attachment-2 font-size-15 d-xl-inline-block" :href="alat.url" target="_blank"></a>
                              <!-- <div class="col" v-if="alat>0">{{ alat_key }} <code class="highlighter-rouge">{{ alat }}</code></div> -->
                            </div>
                          </div>
                        </b-card-text>
                        <div v-if="is_user_admin && inti.status_permohonan == 'Semakan'" class="button-items">
                          <!-- <button class="btn btn-sm btn-outline-primary" href="javascript:void(0);">papar</button> -->
                          <button class="btn btn-sm btn-outline-primary" @click="luluskanPermohonan(inti.id)">lulus</button>
                          <button class="btn btn-sm btn-outline-warning" @click="tidakLuluskanPermohonan(inti.id)">tidak lulus</button>
                        </div>
                      </b-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>